import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InitFailureService {
  affiliateSettingsFailed = false;
  translationsFailed = false;

  get hasFailure(): boolean {
    return this.affiliateSettingsFailed || this.translationsFailed;
  }
}
